import { useSelector } from "react-redux";
import logger from "../../utils/logger/library";

/**
 * Hook that checks whether the current path matches any of the paths defined in
 * ocelot.flp.authorinfo. This controls whether the AuthorInfo component
 * will render or not.
 *
 * @param {string} path
 * @returns {Boolean}
 */
const useIsAuthorInfoHidden = (path) => {
    const authorinfoFlag = useSelector((state) => state.flp?.authorinfo);
    if (authorinfoFlag) {
        try {
            const authorinfoHiddenPaths = JSON.parse(authorinfoFlag).hidden;
            return authorinfoHiddenPaths.includes(path);
        } catch (error) {
            logger.error(
                "(useIsAuthorInfoHidden) Unable to retrieve authorinfo list from flp flag",
                error
            );
        }
    }

    return false;
};

export default useIsAuthorInfoHidden;
